import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IAmplitudeOfferPromotionTrackingParams} from "./get_amplitude_offer_promotion_event_properties";
import {getAmplitudeOfferPromotionModalCloseEventProperties} from "./get_amplitude_offer_promotion_modal_close_event_properties";
import {trackAmplitudeOfferSelectPromotion, trackAmplitudeOfferViewPromotion} from "./track_amplitude_offer_promotion_events";

export const trackAmplitudePromotionModalViewPromotion = (context: IAmplitudeOfferPromotionTrackingParams) => {
    trackAmplitudeOfferViewPromotion(context);
};

export const trackAmplitudePromotionModalSelectPromotion = (context: IAmplitudeOfferPromotionTrackingParams) => {
    trackAmplitudeOfferSelectPromotion(context);
};

export const trackAmplitudePromotionModalClose = (context: IAmplitudeOfferPromotionTrackingParams) => {
    trackAmplitudeEvent(
        "button_click",
        getAmplitudeOfferPromotionModalCloseEventProperties({
            buttonCategory: context.location,
            itemId: context.itemId,
            creativeName: context.creativeName,
            promotionId: context.promotionId
        })
    );
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IAmplitudeOfferPromotionTrackingParams} from "./get_amplitude_offer_promotion_event_properties";
import {getAmplitudeOfferPromotionModalCloseEventProperties} from "./get_amplitude_offer_promotion_modal_close_event_properties";
import {trackAmplitudeOfferSelectPromotion, trackAmplitudeOfferViewPromotion} from "./track_amplitude_offer_promotion_events";

export const trackAmplitudePromotionModalViewPromotion = (context: IAmplitudeOfferPromotionTrackingParams) => {
    trackAmplitudeOfferViewPromotion(context);
};

export const trackAmplitudePromotionModalSelectPromotion = (context: IAmplitudeOfferPromotionTrackingParams) => {
    trackAmplitudeOfferSelectPromotion(context);
};

export const trackAmplitudePromotionModalClose = (context: IAmplitudeOfferPromotionTrackingParams) => {
    trackAmplitudeEvent(
        "button_click",
        getAmplitudeOfferPromotionModalCloseEventProperties({
            buttonCategory: context.location,
            itemId: context.itemId,
            creativeName: context.creativeName,
            promotionId: context.promotionId
        })
    );
};
